import React from "react";
import {Badge, Form} from "react-bootstrap";
import {FaCheck} from 'react-icons/fa';
import {BiCut} from "react-icons/bi"
import {useCouponCodeQuery} from "../../../hooks/useCouponCodeQuery";
import {AiFillCaretLeft} from "react-icons/ai";
import {useOnCouponCodeSelect} from "../../../hooks/useOnCouponCodeSelect";
import { VisibilityType } from "../../../definitions/enums";

export const CouponCode = () => {
    const {couponModel, error} = useCouponCodeQuery();
    const {applied, setPromotionCode} = useOnCouponCodeSelect();

    if (error || !couponModel?.campaign || couponModel?.statusCode == VisibilityType.NonSite) return <></>;

    return (
        <>
            <div id="product-coupon-code" className="mt-3 position-relative">
                <BiCut size={20}
                       aria-hidden="true"
                       className="position-absolute top-0 start-0 translate-middle text-muted"/>
                <div className="d-flex align-items-end flex-wrap justify-content-between pt-1">
                    <div>
                        <div className="mb-2">
                            <Badge bg="warning" text="dark" className="fw-bold coupon-code-badge">
                                Coupon
                                <AiFillCaretLeft className="text-white" aria-hidden/>
                            </Badge>
                            <strong>LIMITED TIME OFFER!</strong>
                        </div>
                        {applied ? (
                            <>
                                <small className="text-muted text-end">
                                    Coupon Code: {couponModel.campaign}
                                </small>
                                <br/>
                                <FaCheck className="me-1 text-success"/>
                                <strong className="text-success">
                                    {couponModel.appliedDescription}
                                </strong>
                            </>
                        ) : (
                            <Form.Check
                                type='checkbox'
                                id='coupon-code'
                                className="ms-1"
                                onChange={() => setPromotionCode(couponModel.campaign)}
                                label={(
                                    <span>
                                        <strong className="text-success">
                                            {couponModel.unappliedDescription}
                                        </strong>{' '}
                                        <br/>
                                        <small className="text-muted text-end">
                                            Coupon Code: {couponModel.campaign}
                                        </small>
                                    </span>
                                )}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}